import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import SlidellHeroSection from "./components/HeroSection";
import SlidellStickyNav from "./components/StickyNav";
import SlidellProcessingTimeSection from "./components/ProcessingTimeSection";
import SlidellServicesSection from "./components/ServicesSection";
import SlidellLocalAreaSection from "./components/LocalAreaSection";
import SlidellTravelTimingSection from "./components/TravelTimingSection";
import SlidellDestinationsSection from "./components/DestinationsSection";
import SlidellTestimonialsSection from "./components/TestimonialsSection";
import SlidellAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SlidellComparisonSection from "./components/ComparisonSection";
import SlidellMistakesSection from "./components/MistakesSection";
import SlidellHowItWorksSection from "./components/HowItWorksSection";
import SlidellFAQSection, { faqs } from "./components/FAQSection";
import SlidellHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SlidellFinalCTA from "./components/FinalCTA";

export default function SlidellPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Slidell"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/slidell"
        title="Emergency Passport Slidell, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Slidell, LA — as fast as 24 hours. Serving Northshore families, commuters, and Gulf Coast travelers in St. Tammany Parish. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Slidell, Louisiana"
        geoPosition="30.2749;-89.7812"
        faqs={faqs}
        servicesSchema={[
          { name: "Emergency Passport", description: "Urgent passport processing for Slidell travelers with immediate departure needs — as fast as 24 hours for St. Tammany Parish residents." },
          { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Slidell with an expired or expiring passport." },
          { name: "New Passport", description: "First-time passport application assistance for Slidell and Northshore families." },
          { name: "Lost or Stolen Passport", description: "Passport replacement for lost or stolen passports with DS-64 form guidance in Slidell, LA." },
          { name: "Child Passport", description: "Passport services for minors under 16 with parental consent guidance for St. Tammany Parish families." },
          { name: "Name Change", description: "Passport correction and name change service for Slidell residents after marriage or legal changes." },
          { name: "Second Passport", description: "Second passport service for Northshore commuters and Gulf Coast travelers from Slidell." },
        ]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <SlidellHeroSection />
      <SlidellStickyNav />
      <SlidellProcessingTimeSection />
      <SlidellLocalAreaSection />
      <SlidellServicesSection />
      <SlidellTravelTimingSection />
      <SlidellDestinationsSection />
      <SlidellTestimonialsSection />
      <SlidellAcceptanceFacilitiesSection />
      <SlidellComparisonSection />
      <SlidellMistakesSection />
      <SlidellHowItWorksSection />
      <SlidellFAQSection />
      <SlidellHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/slidell" state="LA" />
      <SlidellFinalCTA />
    </div>
  );
}